// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OPus","col":"styles_col__2zC64"};